var propsOfThePage = {
    viewportWidth: $(window).width(),
};

if($('.l-headerHome').length) {
    var swiper__produtosHeaderHome = new Swiper('.swiper__produtosHeaderHome', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 0,
        loop: true,
    });

    swiper__produtosHeaderHome.on('slideChange', function () {
        console.log(swiper__produtosHeaderHome.activeIndex);
        setTimeout(function(){
            if ($('.swiper-slide-active').hasClass('text1')) {
                $('.title-2').fadeOut(function (){
                    $('.title-1').fadeIn();
                });
            } else {
                $('.title-1').fadeOut(function (){
                    $('.title-2').fadeIn();
                });
            }
        }, 250);
    });

    // changes if banner '50 anos' is active (9/1/20)
    // var svgRedHeader = $('.l-headerHome .bottomEffect_orange svg path');
    // //swiper__produtosHeaderHome.on('slideChange', function () {
    //     console.log(swiper__produtosHeaderHome.activeIndex);
    //     setTimeout(function(){
    //         if ($('.swiper-slide-active').hasClass('swiper-slide--50anos')) {
    //             svgRedHeader.css('fill', '#3774cf');
    //             console.log('teste');
    //         } else {
    //             svgRedHeader.removeAttr('style');
    //         }
    //     }, 250);
    //});
}

if($('#clientes').length) {
    var containerClientesWidth = $('#clientes .u-container').width();
    var addWidth = (propsOfThePage.viewportWidth - containerClientesWidth) / 2;
    var finalWidth = $('#clientes .slideHero').width() + addWidth + 35;
    $('#clientes .slideHero').css('min-width', finalWidth);

    var swiper__clientesHome = new Swiper('.swiper__clientesHome', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        // loopedSlides: 30,
        autoplay: {
            delay: 1500,
        },
        breakpoints: {
            680: {
                autoplay: {
                    delay: 1200,
                },
                centeredSlides: true
            }
        }
    });

    $('.swiper__clientes__controls').on('click', function() {
        swiper__clientesHome.slideNext();
    });
}